import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { ErrorBoundary } from "../../../components/ErrorBoundary.js";
import { useAppInteractionHandlers } from "../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useEvent } from "../hooks/useEvent.js";
import { EventName } from "./EventName.js";
import "react";
import { Card, ColorSquare, Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Events/shared/EventCard.tsx
function EventCard(props) {
	const appInteractionHandlers = useAppInteractionHandlers();
	const { data, loading } = useEvent({ eventId: props.eventId });
	const isClickable = !data?.event.deleted && !!appInteractionHandlers?.onClickEvent;
	if (!props.eventId) return null;
	if (!loading && !data?.event) return null;
	return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Card, {
		className: classnames("bg-surface-subtle relative overflow-hidden", { "cursor-pointer": isClickable }),
		borderRadius: "sm",
		onClick: isClickable ? () => appInteractionHandlers?.onClickEvent?.(props.eventId) : void 0,
		padding: "xs",
		children: !data ? /* @__PURE__ */ jsxs("div", {
			className: "p-xxs w-48",
			children: [/* @__PURE__ */ jsx(Skeleton.Text, { chars: 35 }), /* @__PURE__ */ jsx(Skeleton.Text, { chars: 50 })]
		}) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({ "opacity-50": data.event.deleted }, "py-xxs flex flex-col justify-center"),
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex flex-wrap sm:justify-between",
				children: [/* @__PURE__ */ jsxs("div", { children: [data.eventType.color && /* @__PURE__ */ jsx(ColorSquare, {
					color: data.eventType.color,
					marginRight: true
				}), /* @__PURE__ */ jsx(EventName, {
					id: props.eventId,
					name: data.event.title
				})] }), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(DateTime$1, { timestamp: data.event.date }) })]
			}), /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle max-w-80 truncate text-sm font-medium capitalize",
				children: data.event.subTitle
			})]
		}), data.event.deleted && /* @__PURE__ */ jsx("div", {
			className: "z-sticky bg-critical/10 text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
			children: "DELETED"
		})] })
	}) });
}
//#endregion
export { EventCard };

//# sourceMappingURL=EventCard.js.map